export { AwesomeIcon } from './AwesomeIcon.component.js';
